import React, { Component } from 'react'
import TotalBalanceListItem from '../components/ui-components/TotalBalanceListItem'
import { Grid, Typography, Stack, IconButton, Divider, Container, Button, Box } from "@mui/material"
import wyzrTheme from '../styles/customTheme';


export class TotalBalanceTransactionItem extends Component {
    render() {
        return (
            <>
                <Box
                    sx={{ color: this.props.active == this.props.transaction.category ? "text.primary" : "grey.600", width: "100%", cursor: "default", padding: 0, width: "100%", boxShadow: this.props.active == this.props.transaction.category ? 3 : 0, backgroundColor: this.props.active === this.props.transaction.category ? wyzrTheme.palette.primary.light : "", borderRadius: "14px !important", verticalAlign: "middle" }}

                >


                    <Grid
                        container
                        // mt={1}
                        mb={0}
                        width="100%"
                        justifyContent="space-between"
                        alignItems="flex-end"
                        className={this.props.transaction.amount === null ? "blur" : ""}
                    >
                        <Grid item sx={{ width: "100%", padding: "15px" }}>
                            {/* <Container style={{ display: "flex", alignItems: "start", justifyContent: "space-between", flexDirection: "row", width: "100%" }}>
                             */}
                            <Container style={{ display: "grid", gridTemplateColumns: "auto auto auto", justifyContent: "space-between" }}>

                                <Typography variant="body2" fontWeight={700} mb={1} fontSize={"1.1rem"} sx={{ textTransform: "uppercase" }} >
                                    {this.props.transaction.category}
                                </Typography>
                                {this.props.transaction.category?.toLowerCase() === "current" ?
                                    <Typography variant="body1" fontSize={"0.9rem"} fontWeight={500} >
                                        Balance
                                    </Typography> : <Typography variant="body1" sx={{ opacity: "0%" }} fontSize={"0.9rem"} fontWeight={500} >
                                        Balance after
                                    </Typography>
                                }
                                <Typography fontWeight={800} fontSize={"1.2rem"} sx={{ display: "flex", justifyContent: "end" }}>
                                    {this.props.transaction.prefix}{this.props.transaction.total}
                                </Typography>
                                {
                                    this.props.accounts.map((item) => (

                                        item.accountSubText === this.props.transaction.category ?
                                            <>
                                                <TotalBalanceListItem key={item.id} item={item} isCurrent={this.props.transaction.category?.toLowerCase() === "current"} />
                                            </>

                                            : null

                                    ))
                                }
                            </Container>
                        </Grid>

                    </Grid>
                </Box>


                <Divider light />
            </>
        )
    }
}

export default TotalBalanceTransactionItem